import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useDirectoryAvailability } from "../lib/useDirectoryAvailability";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const DISCOVER_LINKS = [
  ["/restaurants", "nav.restaurants", "restaurants"],
  ["/shopping", "nav.shopping", "shopping"],
  ["/directory", "nav.directory", "directory"],
];

export const useDiscoverLinks = () => {
  const counts = useDirectoryAvailability();
  return counts ? DISCOVER_LINKS.filter(([, , s]) => counts[s] > 0) : [];
};

export const DiscoverMenu = () => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const links = useDiscoverLinks();
  if (!links.length) return null;
  const active = links.some(([to]) => pathname === to || pathname.startsWith(`${to}/`));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="nav-discover-trigger"
        className={`inline-flex items-center gap-1 px-1.5 2xl:px-3 py-2 text-[13px] 2xl:text-sm whitespace-nowrap rounded-md outline-none transition-colors duration-200 ${active ? "text-gold" : "text-white/70 hover:text-white"}`}>
        {t("nav.discover")} <ChevronDown size={14} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-surface border-white/10 text-white min-w-[220px]" data-testid="nav-discover-menu">
        {links.map(([to, key]) => (
          <DropdownMenuItem key={to} asChild className="focus:bg-white/[0.06] focus:text-gold cursor-pointer">
            <NavLink to={to} data-testid={`nav-${to.slice(1)}`}>{t(key)}</NavLink>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
